module.exports = __webpack_public_path__ + "static/media/plant.71907481.svg";